export default {
  zIndexForSeatingMap: 10,
  zIndexForSpinner: 15,
  zIndexForDropdowns: 1400,
  zIndexForCustomOverlays: 1000,
  zIndexForNavbarBanner: 1098,
  zIndexForDrawerOverlays: 1249,
  zIndexForDrawers: 1250,
  zIndexForModals: 1400,
  zIndexForPopovers: 1500,
  /**
   * Max 32 bit integer (2147483647) - 1. This value is often used as a max number in various contexts,
   * so we do -1 so to not conflict with third parties.
   *
   * This should still be considered as 'max' within the showpass frontend boundary.
   */
  zIndexMax: 2147483646,
};
